import { useEffect, useState } from 'react';
import { apiClient } from '@/lib/api/api-client';

/*
  D24 (vault 346): el correo y el WhatsApp públicos no viven en el código. Los carga la plataforma
  (`PUT /api/platform-settings`) y se leen de `GET /api/public/plataforma/contacto`. Mientras estén
  vacíos (o si el pedido falla) no se muestra nada: sólo el formulario.
*/

export interface ContactoPublico {
  correo: string | null;
  whatsapp: string | null;
}

const VACIO: ContactoPublico = { correo: null, whatsapp: null };
let guardado: Promise<ContactoPublico> | null = null;

export function leerContactoPublico(): Promise<ContactoPublico> {
  guardado ??= apiClient
    .get<ContactoPublico>('/api/public/plataforma/contacto')
    .then((c) => ({ correo: c?.correo || null, whatsapp: c?.whatsapp || null }))
    .catch(() => {
      guardado = null;
      return VACIO;
    });
  return guardado;
}

/** Para los tests: el próximo pedido vuelve a leer. */
export function olvidarContactoPublico(): void {
  guardado = null;
}

/** `https://wa.me/59170000000` desde «+591 7000 0000» (sólo dígitos). */
export const enlaceDeWhatsApp = (numero: string): string =>
  `https://wa.me/${numero.replace(/\D/g, '')}`;

export function useContactoPublico(): ContactoPublico {
  const [contacto, setContacto] = useState<ContactoPublico>(VACIO);
  useEffect(() => {
    let vigente = true;
    void leerContactoPublico().then((c) => vigente && setContacto(c));
    return () => {
      vigente = false;
    };
  }, []);
  return contacto;
}
